<template>
  <div class="tooltipIcon">
    <tooltip :text="text" class="hover">
      <span v-if="isDisabled" slot="content">
        <img v-if="imgIcon" :class="['img-border', isDisabled? 'disabled-2': '']" :src="imgIcon">
        <i v-else :class="[icon, isDisabled? 'disabled': '']"></i>
      </span>
      <span v-else slot="content" @click.stop="selected">
        <img v-if="imgIcon" class="img-border" :src="imgIcon">
        <i v-else :class="[icon, isDisabled? 'disabled': '']"></i>
      </span>
    </tooltip>
  </div>
</template>

<script>
import tooltip from '@/components/Tooltip'
import { text } from 'body-parser';
import { type } from 'os';
// import func from '../../../vue-temp/vue-editor-bridge';

export default {
  name: "adx-icon-hover",
  components: {
    "tooltip": tooltip
  },
  props: {
    icon:{
      required: true
    },
    text:{
      required: false
    },
    action: {
      required: false
    },
    isDisabled: {
      required: false,
      default: false
    },
    imgIcon: {
      required: false
    }
  },
  mounted() {
  },
  data() {
    return {
      isHover: false,
    }
  },
  methods:{
    selected($event){
      this.$emit('selectedIcon', $event)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
